import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override style for input helper texts (error message)
 */
export const getMuiFormHelperText = (theme: Theme): ThemeStyle => {
  return {
    root: {
      position: 'absolute',
      left: 120,
      top: 'calc( 100% - 4px )',
      maxWidth: 520,
      padding: '10px 16px',

      color: theme.palette.common.white,
      background: theme.palette.common.black,
      border: `1px solid ${theme.palette.common.black}`,

      lineHeight: '20px',
      textAlign: 'left',

      boxSizing: 'border-box',
      borderRadius: theme.shape.borderRadius,
      zIndex: 100,

      '&:before, &:after': {
        position: 'absolute',
        bottom: '100%',
        left: 30,
        border: '7px solid transparent',
        content: '" "',
        height: 0,
        width: 0,
      },

      '&:before': {
        borderBottomColor: theme.palette.common.black,
      },

      '&.Mui-error': {
        color: theme.palette.common.white,
        left: 0,
        margin: '10px 0 0 0',
      },
    },
  };
};
